export const config = {
  region: 'us-east-1',
  userPoolId: 'us-east-1_EOv11IoHi',
  userPoolClientId: 'btkfost60ap672o9mckugrrf3',
  apiBase: '/api/v1',
  cdnBase: 'https://music.minine.games',
};

/** 允许进后台的 Cognito 组 */
export const ALLOWED_GROUPS = ['editor', 'super-admin'];
